// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonPayload__header-a77b9a {
  margin-inline-end: 4px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--base-80);
}

.CommonPayload__icon-b55c86 {
  margin-inline-end: 4px;
  vertical-align: middle;
  fill: var(--base-80);
}

.CommonPayload__text-e063fd {
  white-space: nowrap;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupDescription/LastMessageDescription/CommonPayload/CommonPayload.style.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4BAAA;EACA,4CAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,sBAAA;EACA,oBAAA;AACF;;AAEA;EACE,mBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF","sourcesContent":[".header {\n  margin-inline-end: 4px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--base-80);\n}\n\n.icon {\n  margin-inline-end: 4px;\n  vertical-align: middle;\n  fill: var(--base-80);\n}\n\n.text {\n  white-space: nowrap;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `CommonPayload__header-a77b9a`,
	"icon": `CommonPayload__icon-b55c86`,
	"text": `CommonPayload__text-e063fd`
};
module.exports = ___CSS_LOADER_EXPORT___;
